// extracted by mini-css-extract-plugin
export default {"companyName":"bids_companyName__H9gDM","switch":"bids_switch__QyyvY"};